const round = (n) => Math.round(n * 100) / 100;

export const effectiveQty = (it) => (it.can_send === undefined || it.can_send === null ? it.quantity : it.can_send);

export const isShortItem = (it) => it.can_send !== undefined && it.can_send !== null && it.can_send < it.quantity;

export function orderBalance(o) {
  const goods =
    (o.items || []).reduce((s, it) => s + it.price * effectiveQty(it), 0) +
    (o.swaps || []).reduce((s, w) => s + w.price * w.quantity, 0);
  const sending = goods > 0 ? Math.max(0, goods - (o.discount || 0)) + (o.shipping_cost || 0) : 0;
  const paid = o.total || 0;
  const refunded = o.refunded_total || 0;
  return {
    paid,
    sending: round(sending),
    refunded,
    refundDue: round(Math.max(0, paid - sending - refunded)),
    refundable: round(Math.max(0, paid - refunded)),
  };
}

export const isAdjusted = (o) => (o.items || []).some(isShortItem) || (o.swaps || []).length > 0 || (o.refunds || []).length > 0;
